export default {
  ReferralLinkView: 'ReferralLinkView',
  FinancialSummaryView: 'FinancialSummaryView',
  DashboardAOSections: 'DashboardAOSections',
};
